module.exports = __webpack_public_path__ + "img/img_21@2x.e46285f2.png";